module.exports = __webpack_public_path__ + "img/hazelnut.03c6fd88.png";